// Source of truth - content preserved verbatim from Shubham's writing.

export const profile = {
  name: "Shubham",
  fullName: "Shubham Gaur",
  role: "Quantitative Research • MEV • Systems Engineering",
  location: "Bengaluru, Karnataka, IN",
  email: "shubham.gaur7116@gmail.com",
  pgpPublicKey: `-----BEGIN PGP PUBLIC KEY BLOCK-----
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=loyZ
-----END PGP PUBLIC KEY BLOCK-----`,
};

export const about =
  "Quantitative Researcher specializing in Solana market microstructure, execution systems, and on-chain data analysis. Experienced in developing quantitative models, optimizing transaction execution, designing incentive mechanisms, and extracting market intelligence from large-scale blockchain datasets. Active contributor to open-source DeFi, MEV, and quantitative finance infrastructure.";

export const experience = [
  {
    role: "Quantitative Engineer",
    company: "Astralane",
    period: "Aug 2025 - Present",
    place: "UAE",
    points: [
      "Designed and deployed subsidy strategies to improve competitiveness in subsidy auctions, increasing transaction landing rates and top-of-block positioning across Solana validators.",
      "Optimized transaction execution infrastructure through validator-client-specific routing and delivery strategies, improving execution reliability for latency-sensitive flows.",
      "Collaborated with searcher teams to improve arbitrage execution performance, transaction inclusion rates, and overall execution volume.",
      "Built large-scale on-chain indexing and analytics pipelines to track competitor activity, identify wallet and searcher relationships, and generate market intelligence used in business development and partnership decisions.",
    ],
  },
  {
    role: "Founding Engineer",
    company: "Solsphere AI Inc & Stealth Startup",
    period: "Feb 2025 - Aug 2025",
    place: "Bengaluru",
    points: [
      "AI Compliance Systems: Engineered automated compliance workflows using NLP and vector-based semantic search to parse and validate regulatory documentation.",
      "Security Infrastructure: Built a cross-platform desktop security client using ElectronJS for Mac, Linux, and Windows, focused on device-level integrity and monitoring.",
      "Internal Tooling: Developed a secure RAG pipeline for email-based data retrieval and high-performance database search tools, optimizing internal operations latency.",
    ],
  },
  {
    role: "Software Development Engineer",
    company: "Smartdocs Inc",
    period: "Aug 2024 - Nov 2024",
    place: "Jaipur",
    points: [
      "LLM Optimization: Built a production-grade LLM chatbot; achieved a 55% reduction in API latency through asynchronous parallelization and optimized prompt engineering.",
      "Test Automation: Developed a GUI-based automation suite using Electron and Playwright, reducing manual QA overhead and saving the firm approximately 1L annually.",
      "Full-Stack Delivery: Successfully delivered 2 high-fidelity PoCs and 1 production application using a React, Node.js, and MongoDB stack within a 3-month cycle.",
    ],
  },
  {
    role: "Founding Engineer",
    company: "Stealth Startup",
    period: "Mar 2024 - Jul 2024",
    place: "Jaipur",
    points: [
      "Fundraising Tech Lead: Led technical delivery of PoCs for investor demos, directly enabling seed funding traction through live walkthroughs of functional prototypes.",
      "System Architecture: Developed cross-platform Electron + React applications, improving release compatibility by 90% across various OS environments.",
      "Technical Storytelling: Contributed to pitch decks and VC demos for 3 major firms, translating complex technical architectures into compelling investment narratives.",
    ],
  },
];

export const projects = [
  {
    title: "Power Energy Quant: NYISO Virtuals & Grid Security",
    stack: "Python",
    desc: "Walk-forward study of NYISO day-ahead/real-time virtuals, battery arbitrage bounds, VaR calibration, and N-1 security cost on 47,773 zone-hours (Jan-Jun 2026). Unconditional INC remains profitable out of sample; fitted models do not beat it.",
    tags: ["Python", "Quant", "Power Markets", "NYISO"],
    href: "https://powerenergyquant.com/",
  },
  {
    title: "Polymath: HFT Prediction Market Bot",
    stack: "Rust/Python",
    desc: "Developed a dual-process execution bot for Polymarket; implemented real-time order sizing with tick-level precision and latency tracking using a custom Rust-to-Python socket bridge.",
    tags: ["Rust", "Python", "HFT", "Socket Bridge"],
  },
  {
    title: "Axiom: On-chain Indexer",
    stack: "Rust",
    desc: "Analyzed Jito bundle participation and SOL tip distributions via a high-concurrency pipeline, identifying temporal and 0-slot transaction patterns across Bloxroute/Jito.",
    tags: ["Rust", "Bloxroute", "Jito", "Solana", "On-chain Data"],
  },
  {
    title: "Bounded MPMC Queue",
    stack: "Rust",
    desc: "Implemented a lock-free bounded multi-producer, multi-consumer queue in Rust with zero external dependencies, using Vyukov's ring-buffer design with 128-byte cache-line padding to eliminate false sharing and a two-tier fast-path/park strategy; benchmarked 3-46x faster than mutex-based queues under contention.",
    tags: ["Rust", "Lock-Free", "Concurrency", "Low Latency"],
    href: "https://github.com/shubhamessier/bounded-mpmc",
  },
  {
    title: "Lighter FX: Weekend Pricing Analysis",
    stack: "Python",
    desc: "Reverse-engineered Lighter's weekend FX price updates during traditional market closures, modeling crypto-implied pricing via triangular arbitrage and correlating volume patterns with price decay across the Friday-to-Sunday GMT window.",
    tags: ["Python", "Quant", "FX", "Market Microstructure"],
    href: "https://github.com/shubhamessier/lighter-fx-pricing",
  },
];

export const openSource = [
  {
    title: "Orca Whirlpools",
    pr: "PR #1307",
    desc: "Fixed a transaction-batching bug in harvestAllPosition where the trailing instruction batch was never flushed, causing zero transactions to be sent for small harvests and silently dropping the final batch for larger ones in Orca's concentrated liquidity AMM on Solana.",
    tags: ["TypeScript", "Solana", "AMM", "DeFi"],
  },
  {
    title: "QuantLib",
    pr: "PR #2411",
    desc: "Implemented fair spread computation for FloatFloatSwap in the industry-standard quantitative finance library used across global investment banks.",
    tags: ["C++", "Quantitative Finance", "Open Source"],
  },
  {
    title: "Marginfi-v2",
    pr: "PR #583",
    desc: "Exposed share amount on LendingAccountDeposit/Withdraw/Borrow/Repay events across all 12 event construction sites in mrgnlabs' lending protocol, enabling indexers to reconstruct share-based balances from event history without re-deriving cumulative share price or polling on-chain state.",
    tags: ["Rust", "Solana", "DeFi"],
  },
  {
    title: "Jito-Solana",
    pr: "PR #1438",
    desc: "Ported EntryBytesBudget to normal and bundle consumers in Jito's MEV-enabled Solana validator powering majority of network stake.",
    tags: ["Rust", "Solana", "MEV", "Validator"],
  },
];

export const skills = [
  {
    group: "Languages / Stack",
    items: "Rust (Tokio, Alloy), C++17/20, Python, Linux Kernel Tuning",
  },
  {
    group: "Quant & MEV",
    items: "Jito/MEV-Boost, ClickHouse, Polars",
  },
];

export const education = {
  school: "MBM University, Jodhpur",
  degree: "B.E. in Electronics & Communication Engineering",
  period: "2021 - 2025",
  achievements: [
    "Finalist, National Entrepreneurship Challenge, IIT Bombay (Top 5% of 200+ teams).",
    "Relevant Coursework: Stochastic Processes, Linear Algebra, Information Theory, OS Tuning.",
  ],
};

export const connect = [
  { label: "Email", value: "shubham.gaur7116@gmail.com", href: "mailto:shubham.gaur7116@gmail.com" },
  { label: "LinkedIn", value: "linkedin.com/in/shubhamgaur10", href: "https://linkedin.com/in/shubhamgaur10" },
  { label: "X", value: "x.com/0xshubhamgaur", href: "https://x.com/0xshubhamgaur" },
  { label: "GitHub", value: "github.com/shubhamessier", href: "https://github.com/shubhamessier" },
  { label: "Website", value: "gaurshubham.com", href: "https://gaurshubham.com" },
  { label: "Instagram", value: "instagram.com/shubham.git", href: "https://instagram.com/shubham.git" },
];

// --- Personal writing (grouped into a single collapsible section) ---

export const personal = {
  chapters: [
    {
      no: "01",
      title: "Who am I anyways?",
      body: [
        "Good Question, I'm Shubham, here's my story. Since my childhood, I was fascinated by computers and technology. At 10, I was curious enough to learn PowerPoint on my own. As a result, I spent years of my childhood learning about them, fixing my computer, taking apart hard drives.",
        "I've spent countless hours playing Condition Zero, Total Overdose, Grand Theft Auto, Need For Speed etc. I first learnt programming using QBasic during my school, thanks to Windows XP & computer viruses I learnt the habit of fixing errors, early in life.",
        "Other than programming I enjoy astrophotography, a hobby I picked up casually exploring my phone camera's capabilities, I've captured different shots of moons, stars & nebulas. I have been very much inspired by fictional characters, music & programmers, people such as Iron Man (for putting his passion for technology above everything else), Rocky Balboa (for never giving up), Kevin Mitnick (for being my hacker inspiration), Linus Torvalds (for his beautiful contribution to open source), Karate Kid (for teaching me wax on, wax off!), Pink Floyd (for every one of their life altering hits).",
        "I don't like using proprietary software, I like to use free and open-source software. I like to work with open-source software, and I avoid getting into the walled garden of ecosystems.",
      ],
    },
    {
      no: "02",
      title: "Solitude",
      body: [
        "I do like socialising and meeting new people constantly, but sometimes I just live alone, process my thoughts, work on the things I want to do, rather than just follow where the group goes, I do hate larger groups where the decision making is made by the alpha of the group. I like working with small sets of people, and I enjoy the prospect of knowing everyone closely. The rules change when I travel, I try to strike up conversations with new people, make friends and go along. Apart from this, to really become great at something I need to spend a lot of time alone on it, to gain that unwavering focus is important for me. People play a huge role in that, and through time I have realised one good friend is enough to live a meaningful life, everything good above that is a luxury. I try to make my days even by having an evening chai with my friend outside my home where we discuss our thoughts and ideas.",
      ],
    },
    {
      no: "03",
      title: "Entropy",
      body: [
        "The goal of every journey is to gain more entropy (the ability for life to be spontaneous) all I work for is to gain a little more entropy, that extra ability to indulge in my pursuits without having to think about the constraints. The core of humanly life has always been the pursuit of \"the more\" and I don't find myself very different here.",
      ],
    },
    {
      no: "04",
      title: "Technology",
      body: [
        "As vague it may sound to you, but there's a very specific reason why I'm putting it here. As a child growing up in the 2000s, Science and Technology were noble pursuits and something that provided a deep meaning to life. The ability to understand the universe and see the universe in its true form has always been fascinating. Technology provided a way for me to mask my identity and be cool the understanding of complex systems, devices, protocols, etc., has made me interested to try out different things and make something useful out of it.",
      ],
    },
    {
      no: "05",
      title: "Movement",
      body: [
        "Wait, what? The answer is simple: I don't like limiting myself to specific outcomes and possibilities and settling early in life. I've always wanted to work on different technologies, learn something new every day, change cities, learn about cultures, people, and live life to its meaning to me which is \"change\". It's better to mould life, see its true meaning, and live up to it than to accept what's given by default.",
        "The core of a man's spirit comes from new experiences. I live by this thought, and I try to implement it in my life by trying to go beyond my comfort zone and do things without delving into the spiral of thoughts and possibilities.",
        "Travelling by far the only thing that makes me feel alive and makes me deeply happy, I like travelling to newer countries, learn new language, eat the local food (where the menu isn't in english), make new friends, pick up some new skills along my journey. So far I've learnt scuba diving, surfing, camping and It's a really big part of my life now to self explore the world, I travel solo and sometimes in groups, I'm going to visit a few more countries this year which are listed next.",
      ],
    },
    {
      no: "06",
      title: "Reading List",
      body: ["Books that have made the most impact on me:"],
      books: [
        "Hackers & Painters · Paul Graham",
        "The Last Lecture · Randy Pausch",
        "Matilda · Roald Dahl",
        "Dune · Frank Herbert",
        "Sapiens · Yuval Noah Harari",
        "Ghost in Wires · Kevin Mitnick",
        "Theory of Everything · Stephen W. Hawking",
        "Steve Jobs · Walter Isaacson",
      ],
    },
  ],
  timeline: [
    { year: "2003", text: "Born in Jodhpur, Rajasthan, India" },
    { year: "2010", text: "Used PC for the first time, instant crush" },
    { year: "2015", text: "Started using QBasic in school" },
    { year: "2021", text: "Started Studying Engineering, MBM University Jodhpur" },
    { year: "2022", text: "Used Linux Kernel for the first time, instantly became a cult follower" },
    { year: "2023", text: "Interned at NIT Trichy, Studied Cybersecurity, Reinforcement Learning and dove deeper into AI" },
    { year: "2024", text: "Rebuilt my life after a setback from last year, Joined a early startup, Moved to Jaipur, India" },
    { year: "2024", text: "Left the startup, Joined Smartdocs AI as a Software Engineer, worked on source to pay systems." },
    { year: "2024", text: "Left the company to work on my own saas idea, Meetster, A IRL coffee chat application." },
    { year: "2025", text: "Started Astroyapper.com, an AI astrology bot. left it after some time due to difference of vision with my co-founder." },
    { year: "2025", text: "Joined Solsphere AI Inc as a Software Engineer, Worked on AI Compliance systems. Moved to Bengaluru, India" },
    { year: "2025", text: "Refiguring my life, back to the drawing board." },
  ],
  hobbies: [
    { icon: "🤿", label: "Scuba Diving" },
    { icon: "🏕️", label: "Camping" },
    { icon: "🏄", label: "Surfing" },
  ],
  todo: [
    { icon: "🪂", label: "Sky Diving" },
    { icon: "🏃", label: "Running Ultra Marathon" },
  ],
  countries: [
    { flag: "🇫🇷", name: "France" },
    { flag: "🇯🇵", name: "Japan" },
    { flag: "🇬🇧", name: "United Kingdom" },
    { flag: "🇦🇺", name: "Australia" },
    { flag: "🇧🇷", name: "Brazil" },
    { flag: "🇨🇭", name: "Switzerland" },
    { flag: "🇱🇰", name: "Sri Lanka", visited: true },
  ],
};

export const contactClosing =
  "I'm always looking to meet new people, discuss ideas, or just chat over a chai/coffee. At the end everybody wants a little more spontaneity/entropy in their life isn't it?";
